webpackJsonp([35783957827783],{

/***/ 323:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(11);
	
	var _stylesModule = __webpack_require__(632);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _Search = __webpack_require__(57);
	
	var _Search2 = _interopRequireDefault(_Search);
	
	var _SelectArrows = __webpack_require__(85);
	
	var _SelectArrows2 = _interopRequireDefault(_SelectArrows);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SearchCTA = function (_Component) {
	  _inherits(SearchCTA, _Component);
	
	  function SearchCTA() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SearchCTA);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      searchTerm: '',
	      filter: ''
	    }, _this.updateFilter = function (event) {
	      ga('send', {
	        hitType: 'event',
	        eventCategory: 'Search',
	        eventAction: 'Filter',
	        eventLabel: 'homepage'
	      });
	      var value = event.target.value;
	      _this.setState({ filter: value });
	    }, _this.updateSearchTerm = function (event) {
	      var value = event.target.value;
	      _this.setState({ searchTerm: value });
	    }, _this.search = function () {
	      var _this$state = _this.state,
	          searchTerm = _this$state.searchTerm,
	          filter = _this$state.filter;
	
	      var targetPath = void 0;
	
	      if (filter === 'MEMORY') {
	        targetPath = '/memories';
	      } else if (filter === 'GLASS' || filter === 'WINDOW' || filter === 'TABLEWARE') {
	        targetPath = '/glass';
	      } else {
	        targetPath = '/search';
	      }
	
	      var query = '?term=' + encodeURIComponent(searchTerm);
	
	      if (filter === 'WINDOW' || filter === 'TABLEWARE') {
	        query += '&type=' + filter;
	      }
	
	      ga('send', {
	        hitType: 'event',
	        eventCategory: 'Search',
	        eventAction: 'Submit',
	        eventLabel: 'homepage'
	      });
	      (0, _gatsbyLink.navigateTo)('' + targetPath + query);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  SearchCTA.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: _stylesModule2.default.container },
	      _react2.default.createElement(
	        'label',
	        { className: 'a11y-hide', htmlFor: 'search-cta-filter' },
	        'Glass type filter'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.selectContainer },
	        _react2.default.createElement(
	          'select',
	          {
	            id: 'search-cta-filter',
	            name: 'search-cta-filter',
	            value: this.state.filter,
	            onChange: this.updateFilter
	          },
	          _react2.default.createElement(
	            'option',
	            { value: 'ALL' },
	            'Everything'
	          ),
	          _react2.default.createElement(
	            'option',
	            { value: 'GLASS' },
	            'All Glass'
	          ),
	          _react2.default.createElement(
	            'option',
	            { value: 'WINDOW' },
	            'Glass Windows'
	          ),
	          _react2.default.createElement(
	            'option',
	            { value: 'TABLEWARE' },
	            'Tableware Glass'
	          ),
	          _react2.default.createElement(
	            'option',
	            { value: 'MEMORY' },
	            'Your Memories'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _stylesModule2.default.selectArrows },
	          _react2.default.createElement(_SelectArrows2.default, { size: 16 })
	        )
	      ),
	      _react2.default.createElement(
	        'label',
	        { className: 'a11y-hide', htmlFor: 'search-cta-term' },
	        'Search term'
	      ),
	      _react2.default.createElement('input', {
	        type: 'text',
	        id: 'search-cta-term',
	        name: 'search-cta-term',
	        placeholder: 'Enter a search term',
	        value: this.state.searchTerm,
	        onChange: this.updateSearchTerm
	      }),
	      _react2.default.createElement(
	        'button',
	        { onClick: this.search },
	        _react2.default.createElement(_Search2.default, { size: 16 })
	      )
	    );
	  };
	
	  return SearchCTA;
	}(_react.Component);
	
	exports.default = SearchCTA;
	module.exports = exports['default'];

/***/ }),

/***/ 632:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-components-search-cta----styles-module---container---29TmF","selectContainer":"src-components-search-cta----styles-module---selectContainer---2UNQT","selectArrows":"src-components-search-cta----styles-module---selectArrows---3a-On"};

/***/ }),

/***/ 189:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(11);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _stylesModule = __webpack_require__(236);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _backgroundContainer = __webpack_require__(33);
	
	var _backgroundContainer2 = _interopRequireDefault(_backgroundContainer);
	
	var _Arrow = __webpack_require__(125);
	
	var _Arrow2 = _interopRequireDefault(_Arrow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var id = _ref.id,
	      to = _ref.to,
	      onClick = _ref.onClick,
	      imageSrc = _ref.imageSrc,
	      title = _ref.title,
	      text = _ref.text;
	
	  var Tag = onClick ? 'button' : _gatsbyLink2.default;
	
	  return _react2.default.createElement(
	    Tag,
	    { id: id, to: to, onClick: onClick, className: _stylesModule2.default.container },
	    _react2.default.createElement(
	      _backgroundContainer2.default,
	      { src: imageSrc },
	      _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.inner },
	        _react2.default.createElement(
	          'p',
	          { className: _stylesModule2.default.title },
	          title
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: _stylesModule2.default.text },
	          text
	        )
	      ),
	      _react2.default.createElement(_Arrow2.default, { color: '#fff', size: 32, direction: 'right' })
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 236:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-components-tile-link----styles-module---container---2zIhH","inner":"src-components-tile-link----styles-module---inner---b5KNA","title":"src-components-tile-link----styles-module---title---1Q3h0","text":"src-components-tile-link----styles-module---text---2RkiM"};

/***/ }),

/***/ 125:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var _ref$size = _ref.size,
	      size = _ref$size === undefined ? 16 : _ref$size,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? '#000' : _ref$color,
	      _ref$direction = _ref.direction,
	      direction = _ref$direction === undefined ? 'right' : _ref$direction;
	  return _react2.default.createElement(
	    'svg',
	    {
	      height: size,
	      width: size,
	      xmlns: 'http://www.w3.org/2000/svg',
	      viewBox: '0 0 24 24'
	    },
	    _react2.default.createElement('path', {
	      style: direction === 'left' ? { transformOrigin: '50% 50%', transform: 'rotate(180deg)' } : null,
	      fill: color,
	      d: 'M22 12l-4-4v3H3v2h15v3z'
	    })
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 350:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(11);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(32);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _stylesModule = __webpack_require__(654);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _text = __webpack_require__(4);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _searchCta = __webpack_require__(323);
	
	var _searchCta2 = _interopRequireDefault(_searchCta);
	
	var _backgroundImage = __webpack_require__(100);
	
	var _backgroundImage2 = _interopRequireDefault(_backgroundImage);
	
	var _siteFooter = __webpack_require__(42);
	
	var _siteFooter2 = _interopRequireDefault(_siteFooter);
	
	var _gridContainer = __webpack_require__(188);
	
	var _gridContainer2 = _interopRequireDefault(_gridContainer);
	
	var _gridRow = __webpack_require__(84);
	
	var _gridRow2 = _interopRequireDefault(_gridRow);
	
	var _gridCol = __webpack_require__(122);
	
	var _gridCol2 = _interopRequireDefault(_gridCol);
	
	var _gridWrap = __webpack_require__(34);
	
	var _gridWrap2 = _interopRequireDefault(_gridWrap);
	
	var _tileLink = __webpack_require__(189);
	
	var _tileLink2 = _interopRequireDefault(_tileLink);
	
	var _subHeading = __webpack_require__(48);
	
	var _subHeading2 = _interopRequireDefault(_subHeading);
	
	var _backgroundContainer = __webpack_require__(33);
	
	var _backgroundContainer2 = _interopRequireDefault(_backgroundContainer);
	
	var _itemLink = __webpack_require__(72);
	
	var _itemLink2 = _interopRequireDefault(_itemLink);
	
	var _pillButton = __webpack_require__(8);
	
	var _pillButton2 = _interopRequireDefault(_pillButton);
	
	var _room = __webpack_require__(46);
	
	var _room2 = _interopRequireDefault(_room);
	
	var _tileOne = __webpack_require__(70);
	
	var _tileOne2 = _interopRequireDefault(_tileOne);
	
	var _tileTwo = __webpack_require__(71);
	
	var _tileTwo2 = _interopRequireDefault(_tileTwo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_reactHelmet2.default, { title: 'Home' }),
	    _react2.default.createElement(
	      _backgroundContainer2.default,
	      { src: _room2.default },
	      _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.search },
	        _react2.default.createElement(
	          'h1',
	          null,
	          _text2.default.PAGES.HOMEPAGE.title
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _text2.default.PAGES.HOMEPAGE.subtitle
	        ),
	        _react2.default.createElement(_searchCta2.default, null)
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _stylesModule2.default.lowerSection },
	      _react2.default.createElement(
	        _gridContainer2.default,
	        null,
	        _react2.default.createElement(
	          _gridRow2.default,
	          null,
	          _react2.default.createElement(
	            _gridCol2.default,
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: _stylesModule2.default.itemPreview },
	              _react2.default.createElement(_subHeading2.default, { text: _text2.default.PAGES.HOMEPAGE.itemsTitle }),
	              _react2.default.createElement(
	                'p',
	                null,
	                _text2.default.PAGES.HOMEPAGE.itemsSubtitle
	              ),
	              _react2.default.createElement(_pillButton2.default, {
	                small: true,
	                tag: _gatsbyLink2.default,
	                text: _text2.default.PAGES.HOMEPAGE.itemsSeeAllLinkText,
	                to: _text2.default.PAGES.HOMEPAGE.itemsSeeAllLinkTarget
	              }),
	              _react2.default.createElement(
	                'ul',
	                null,
	                _text2.default.PAGES.HOMEPAGE.itemsIds.split(',').map(function (id) {
	                  return _react2.default.createElement(
	                    'li',
	                    { key: id },
	                    _react2.default.createElement(_itemLink2.default, {
	                      id: id,
	                      imageSizes: '(min-width: 1200px) 244px, (min-width: 1024px) calc(25vw - 2.75rem), (min-width: 768px) calc(50vw - 5rem), calc(100vw - 4rem)'
	                    })
	                  );
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _gridCol2.default,
	            null,
	            _react2.default.createElement(_subHeading2.default, { text: _text2.default.PAGES.HOMEPAGE.moreTitle })
	          ),
	          _react2.default.createElement(
	            _gridCol2.default,
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: _stylesModule2.default.links },
	              _react2.default.createElement(
	                'div',
	                { className: _stylesModule2.default.link },
	                _react2.default.createElement(_tileLink2.default, {
	                  imageSrc: _tileOne2.default,
	                  to: _text2.default.PAGES.HOMEPAGE.historyLinkTarget,
	                  title: _text2.default.PAGES.HOMEPAGE.historyLinkTitle,
	                  text: _text2.default.PAGES.HOMEPAGE.historyLinkText
	                })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: _stylesModule2.default.link },
	                _react2.default.createElement(_tileLink2.default, {
	                  imageSrc: _tileTwo2.default,
	                  to: _text2.default.PAGES.HOMEPAGE.contributeLinkTarget,
	                  title: _text2.default.PAGES.HOMEPAGE.contributeLinkTitle,
	                  text: _text2.default.PAGES.HOMEPAGE.contributeLinkText
	                })
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_siteFooter2.default, null)
	  );
	};
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ }),

/***/ 654:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"search":"src-page-components-homepage----styles-module---search---1bEz1","itemPreview":"src-page-components-homepage----styles-module---itemPreview---11kj8","lowerSection":"src-page-components-homepage----styles-module---lowerSection---M5nkw","links":"src-page-components-homepage----styles-module---links---2dHxk","link":"src-page-components-homepage----styles-module---link---3ShUb"};

/***/ }),

/***/ 362:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _homepage = __webpack_require__(350);
	
	var _homepage2 = _interopRequireDefault(_homepage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _homepage2.default;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-e5f1c984f8bb9cb30e9e.js